import * as actionTypes from '../types/userManual';

const initialState = {
  loading: false,
  settings: {},
  chapters: {
    editing: false,
    editRequest: false,
    deleteRequest: false,
    deleting: false,
    getRequest: false,
    getting: false,
    moveRequest: false,
    moving: false
  },
  chaptersManualsList: [],
  loadedModalVideoViewer: true,
  manuals: {
    editing: false,
    editRequest: false,
    deleteRequest: false,
    deleting: false,
    getRequest: false,
    getting: false,
    moveRequest: false,
    moving: false
  },
  manualsList: [],
  videoViewer: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_USER_MANUAL:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_USER_MANUAL_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: payload
      };
    case actionTypes.GET_USER_MANUAL_FAIL:
      return {
        ...state,
        loading: false
      };

    case actionTypes.SET_USER_MANUAL:
      return {
        ...state,
        loading: true
      };
    case actionTypes.SET_USER_MANUAL_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case actionTypes.SET_USER_MANUAL_FAIL:
      return {
        ...state,
        loading: false
      };
    case actionTypes.GET_LIST_CHAPTERS:
    case actionTypes.VIDEO_VIEWER_BY_STOCK_OPEN:
      return {
        ...state,
        chapters: {
          getRequest: false,
          getting: true
        }
      };
    case actionTypes.GET_LIST_CHAPTERS_SUCCESS:
      return {
        ...state,
        chapters: {
          getRequest: true,
          getting: false
        },
        chaptersManualsList: payload
      };
    case actionTypes.VIDEO_VIEWER_BY_STOCK_OPEN_SUCCESS:

      return {
        ...state,
        chaptersManualsList: payload.chaptersManualsList,
        loadedModalVideoViewer: true,
        manualsList: payload.manualsList,
        videoViewer: true
      };
    case actionTypes.GET_LIST_CHAPTERS_FAIL:
    case actionTypes.VIDEO_VIEWER_BY_STOCK_OPEN_FAIL:
      return {
        ...state,
        chapters: {
          getRequest: false,
          getting: false
        }
      };
    case actionTypes.ADD_OR_EDIT_CHAPTER:
      return {
        ...state,
        chapters: {
          editing: true,
          editRequest: false
        }
      };
    case actionTypes.ADD_OR_EDIT_CHAPTER_SUCCESS:
      return {
        ...state,
        chapters: {
          editing: false,
          editRequest: true
        }
      };
    case actionTypes.ADD_OR_EDIT_CHAPTER_FAIL:
      return {
        ...state,
        chapters: {
          editing: false,
          editRequest: false
        }
      };
    case actionTypes.ADD_OR_EDIT_MANUAL:
      return {
        ...state,
        manuals: {
          editing: true,
          editRequest: false
        }
      };
    case actionTypes.ADD_OR_EDIT_MANUAL_SUCCESS:
      return {
        ...state,
        manuals: {
          editing: false,
          editRequest: true
        }
      };
    case actionTypes.ADD_OR_EDIT_MANUAL_FAIL:
      return {
        ...state,
        manuals: {
          editing: false,
          editRequest: false
        }
      };
    case actionTypes.CHAPTERS_INIT:
      return {
        ...state,
        chapters: initialState.chapters
      };
    case actionTypes.DELETE_CHAPTER:
      return {
        ...state,
        chapters: {
          ...state,
          deleteRequest: false,
          deleting: true
        }
      };
    case actionTypes.DELETE_CHAPTER_SUCCESS:
      return {
        ...state,
        chapters: {
          ...state,
          deleteRequest: true,
          deleting: false
        }
      };
    case actionTypes.DELETE_CHAPTER_FAIL:
      return {
        ...state,
        chapters: {
          ...state,
          deleteRequest: true,
          deleting: false
        }
      };
    case actionTypes.DELETE_MANUAL:
      return {
        ...state,
        manuals: {
          ...state,
          deleteRequest: false,
          deleting: true
        }
      };
    case actionTypes.DELETE_MANUAL_SUCCESS:
      return {
        ...state,
        manuals: {
          ...state,
          deleteRequest: true,
          deleting: false
        }
      };
    case actionTypes.DELETE_MANUAL_FAIL:
      return {
        ...state,
        manuals: {
          ...state,
          deleteRequest: true,
          deleting: false
        }
      };
    case actionTypes.MOVE_CHAPTER:
      return {
        ...state,
        chapters: {
          ...state,
          moveRequest: false,
          moving: true
        }
      };
    case actionTypes.MOVE_CHAPTER_SUCCESS:
      return {
        ...state,
        chapters: {
          ...state,
          moveRequest: true,
          moving: false
        }
      };
    case actionTypes.MOVE_CHAPTER_FAIL:
      return {
        ...state,
        chapters: {
          ...state,
          moveRequest: false,
          moving: false
        }
      };
    case actionTypes.MOVE_MANUAL:
      return {
        ...state,
        manuals: {
          ...state,
          moveRequest: false,
          moving: true
        }
      };
    case actionTypes.MOVE_MANUAL_SUCCESS:
      return {
        ...state,
        manuals: {
          ...state,
          moveRequest: true,
          moving: false
        }
      };
    case actionTypes.MOVE_MANUAL_FAIL:
      return {
        ...state,
        manuals: {
          ...state,
          moveRequest: false,
          moving: false
        }
      };
    case actionTypes.VIDEO_VIEWER_OPEN:
      return {
        ...state,
        manualChapterNumId: payload.manualChapterNumId,
        manualNumId: payload.manualNumId,
        loadedModalVideoViewer: true,
        videoViewer: true
      };
    case actionTypes.VIDEO_VIEWER_CLOSE:
      return {
        ...state,
        videoViewer: false
      };
    default:
      return state;
  }
};

export default reducer;
